import { useState, useEffect } from 'react';
import { MessageCircle, X, ArrowUpRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import LeadForm from '@/components/shared/LeadForm';

export const StickyCTA = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <>
          {/* Desktop floating pill */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            className="fixed bottom-8 right-8 z-40 hidden lg:block"
          >
            {!isOpen ? (
              <button
                onClick={() => setIsOpen(true)}
                className="group bg-[#1A1008] text-white shadow-2xl shadow-[#1A1008]/20 rounded-full px-6 py-3.5 text-[13px] font-medium tracking-wide hover:bg-[#3D1C11] active:scale-[0.98] transition-all flex items-center gap-2.5"
                data-testid="sticky-talk-to-us-cta"
              >
                Talk to Us
                <ArrowUpRight size={14} className="opacity-50 group-hover:opacity-80 transition-opacity" />
              </button>
            ) : (
              <motion.div
                initial={{ opacity: 0, scale: 0.95, y: 8 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                className="bg-white rounded-2xl shadow-2xl shadow-[#1A1008]/10 border border-[rgba(61,28,17,0.06)] p-7 w-[380px]"
              >
                <div className="flex justify-between items-center mb-5">
                  <h3 className="text-lg font-semibold text-[#1A1008]">Let's Talk</h3>
                  <button onClick={() => setIsOpen(false)} className="p-1.5 hover:bg-[#FAF5EF] rounded-full transition-colors">
                    <X size={16} className="text-[#6B5B50]" />
                  </button>
                </div>
                <LeadForm
                  sourceForm="sticky-cta"
                  compact
                  onSuccess={() => setTimeout(() => setIsOpen(false), 2000)}
                />
              </motion.div>
            )}
          </motion.div>

          {/* Mobile bottom bar */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-white/95 backdrop-blur-xl border-t border-[rgba(61,28,17,0.06)] p-3 safe-area-bottom"
          >
            <button
              onClick={() => setIsOpen(true)}
              className="w-full bg-[#1A1008] text-white py-3.5 rounded-full text-[14px] font-medium tracking-wide"
            >
              Talk to Us
            </button>
          </motion.div>

          {/* Mobile modal */}
          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 z-50 lg:hidden bg-black/30 backdrop-blur-sm flex items-end"
                onClick={() => setIsOpen(false)}
              >
                <motion.div
                  initial={{ y: '100%' }}
                  animate={{ y: 0 }}
                  exit={{ y: '100%' }}
                  onClick={(e) => e.stopPropagation()}
                  className="bg-white rounded-t-2xl w-full p-7 max-h-[85vh] overflow-y-auto"
                >
                  <div className="flex justify-between items-center mb-5">
                    <h3 className="text-lg font-semibold text-[#1A1008]">Let's Talk</h3>
                    <button onClick={() => setIsOpen(false)} className="p-1.5"><X size={16} className="text-[#6B5B50]" /></button>
                  </div>
                  <LeadForm sourceForm="sticky-cta-mobile" compact onSuccess={() => setTimeout(() => setIsOpen(false), 2000)} />
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
